<template>
  <div class="subscribe-bar">
    <div class="subscribe-tag"></div>
    <div class="subscribe-tag__text">
      <span class="subscribe-tag__text-inner">{{ cornerText }}</span>
    </div>
    <div class="left-part">
      <img class="star-img" :src="cover" alt="标题图" />
    </div>
    <div class="right-part">
      <span class="event-title">{{ title }}</span>
      <span class="event-time">{{ subTitle }}</span>
      <button class="btn-subscribe" :class="btnClassNames" type="button" @click="handleClick">
        <!-- 订阅之后，并且还没有开始才展示 -->
        <van-count-down v-if="isBooking && isPending" :time="countdownTime" format="DD天HH时mm分后开始" />
      </button>
    </div>
  </div>
</template>

<script>
import { track, getQuery, bridge, get, env } from "@changba/funny";

export default {
  name: "SubscribeBar",
  props: {
    star: {
      type: Object,
      required: true,
      default: () => {},
    },
    now: {
      type: String,
      required: true,
    },
    date: {
      type: String,
    },
    state: {
      type: Number,
    },
  },
  computed: {
    cover() {
      return this.star.room?.cover || "";
    },
    cornerText() {
      return this.star.room?.cornerText || "";
    },
    title() {
      return this.star.room?.title || "";
    },
    subTitle() {
      return this.star.room?.subTitle || "";
    },
    btnClassNames() {
      return {
        "is-end": this.isEnd,
        "is-running": this.isRunning,
        "is-pending": this.isBooking && this.isPending,
      };
    },
    countdownTime() {
      return this.startTime.getTime() - this.nowTime.getTime();
    },
    nowTime() {
      return new Date(this.now.replace(/-/g, "/"));
    },
    startTime() {
      return new Date(this.star.room?.timeRange?.[0]?.replace(/-/g, "/"));
    },
    endTime() {
      return new Date(this.star.room?.timeRange?.[1]?.replace(/-/g, "/"));
    },
    isRunning() {
      return this.nowTime >= this.startTime && this.nowTime <= this.endTime;
    },
    isBooking() {
      return this.star.room?.isSubscribed;
    },
    isPending() {
      return this.nowTime < this.startTime;
    },
    isEnd() {
      return this.nowTime > this.endTime;
    },
  },
  methods: {
    handleClick() {
      // 活动已结束
      if (this.isEnd) {
        return;
      }
      // 活动进行中
      else if (this.isRunning) {
        track("click_element_H5_ktv", {
          element_content: this.star.tab,
          element_content_ktv: "进入大合唱",
        });
        const refsrc = getQuery("refsrc");
        bridge.openPage(`changba://?ac=liveroom&hideguide=1&roomid=${this.star.room.roomid}&source=${refsrc}`);
      } else if (this.isBooking) {
        this.$toast("活动即将开始，再等一等哦～");
      } else {
        this.requestSubscribe();
      }
    },
    async requestSubscribe() {
      if (!env.browser.isChangba) {
        this.$toast("打开唱吧App参与");
        return;
      }
      const resp = await get({
        url: "/api/activity/singWithYou/subscribe",
        data: {
          startTime: this.star.room?.timeRange?.[0],
        },
      });
      track("click_element_H5_ktv", {
        element_content: this.star.tab,
        element_content_ktv: "-预约大合唱",
      });
      if (resp.code === 1) {
        // 不用手刷了，直接前端修改数据就OK
        this.$emit("subscribe");
        this.$toast("预约成功，活动开始前15分钟提醒");
      } else {
        this.$toast(resp.msg || "订阅失败，请稍后再试试吧");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.subscribe-bar {
  width: 708px;
  height: 220px;
  margin-top: 50px;
  background-image: url("../assets/subscribe-bg.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  margin-bottom: 38px;
  display: flex;
}

.left-part {
  width: 187px;
  height: 190px;
  margin-left: 46px;
  margin-top: 15px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.star-img {
  border-radius: 58px 14px 58px 14px;
}

.right-part {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 298px;
  margin-left: 48px;
  margin-top: 20px;
}

.event-title {
  height: 44px;
  font-size: 52px;
  color: #faeaff;
  text-align: center;
  font-family: PingFang SC;
}

.event-time {
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #f6daff;
  line-height: 37px;
  margin-top: 13px;
}

.subscribe-tag {
  width: 144px;
  height: 127px;
  z-index: 5;
  position: absolute;

  &::before {
    background-image: url("../assets/subscribe-tag.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: -11px;
    left: -11px;
    content: "";
    width: 144px;
    height: 127px;
    display: inline-block;
  }

  &__text {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    white-space: nowrap;
    line-height: 30px;
    transform: rotate(-40deg) translate(-24px, 8px);
    display: inline-block;
    position: absolute;
    z-index: 11;
    left: -10px;

    &-inner {
      display: inline-block;
      width: 140px;
      text-align: center;
    }
  }
}

.btn-subscribe {
  width: 230px;
  height: 78px;
  background-image: url("../assets/btn-subscribe.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 13px;

  ::v-deep {
    .van-count-down {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 33px;
    }
  }

  &.is-pending {
    width: 298px;
    background-image: url("../assets/btn-countdown.png");
  }

  &.is-running {
    background-image: url("../assets/btn-join-sing.png");
  }

  &.is-end {
    background-image: url("../assets/btn-end.png");
  }
}
</style>
